import { Popover, RealTime, CurrentUser, DeviceMeta } from 'Roblox'; 
import angular from "angular";
import notificationStreamModule from "../notificationStreamModule";

function notificationStreamController($scope, $document, $timeout, notificationStreamService, notificationStreamUtility, userService, eventStreamService,
    gameUpdatesService, gameUpdatesUtility, gameUpdatesConstants, $log) {
    "ngInject";

    $scope.updatePopoverLayout = function () {
        if (Popover) {
            $timeout(
                function () {
                    return Popover.setUpTrianglePosition($scope.layout.dataBindSelector, $scope.layout.dataContainerSelector);
                });
        }
    }

    $scope.buildNotificationsList = function (notifications) {
        var userIds = [];

        notifications.forEach(function (notification) {
            var metaDataCollection = notification.metadataCollection,
                notificationType = notification.notificationSourceType,
                eventDate, i;

            if (!notificationStreamUtility.isNotificationTypeValid(notificationType)) {
                return;
            }

            if (!notificationStreamUtility.isGameUpdateNotification(notificationType)) {
                metaDataCollection.forEach(function (userData) {
                    var user = notificationStreamUtility.normalizeUser(notificationType, userData);
                    if (user && user.userId != null && user.userName != null) {
                        var userId = user.userId;
                        var userName = user.userName;
                        if ($scope.library.userIdList.indexOf(userId) > -1) {
                            return false;
                        } else {
                            userIds.push(userId);
                            $scope.library.userIdList.push(userId);
                            $scope.library.userLibrary[userId] = {
                                id: userId,
                                name: userName,
                                profileLink: notificationStreamUtility.getAbsoluteUrl(notificationStreamUtility.links.profileLink, { id: userId })
                            }
                        }
                    }
                });
            }

            notification.isClickable = notificationStreamUtility.isCardClickable(notification);

            if ($scope.notificationIds.indexOf(notification.id) < 0) {
                $scope.notificationIds.push(notification.id);
            }

            $scope.notifications[notification.id] = notification;
        });

        $scope.layout.emptyNotificationEnabled = $scope.notificationIds.length === 0;

        // Get user avatars.
        if (userIds.length > 0) {
            userService.getUserAvatar(userIds).then(
                function (data) {
                    if (data && data.length > 0) {
                        data.forEach(function (userAvatar, index) {
                            $scope.library.userLibrary[userIds[index]]["thumbnail"] = userAvatar;
                        });
                    }
                },
                function () {
                    $log.debug("----- getUserAvatar request failed ----");
                }
            );
        }
    }

    // Builds aggregate game update notification and populates
    // the model collection.
    $scope.buildGameUpdateNotifications = function (gameUpdateNotifications) {
        if (!gameUpdateNotifications || gameUpdateNotifications.length === 0) {
            return;
        }

        var gameUpdateModels = $scope.library.gameUpdateModels;

        // Start getting game followings, for retrieving full list of game updates.
        // This is due to notification stream keeping only latest 3 updates per 12-hour bucket.
        gameUpdatesService.getGameFollowingsForUserAsync($scope.library.currentUserId).then(
            function (gameFollowings) {
                var i, universeIds = [];

                // Get list of followed universe ids
                for (i = 0; i < gameFollowings.length; i++) {
                    universeIds.push(gameFollowings[i].universeId);
                }

                // Start getting game updates.
                return gameUpdatesUtility.getGameUpdatesAsync(universeIds, gameUpdateModels);
            }
        ).then(
            function (gameUpdates) {
                var aggregateNotification = gameUpdatesUtility.aggregateGameUpdateNotifications(gameUpdateNotifications, gameUpdateModels),
                    singleGameUpdateModel;

                if (!aggregateNotification) {
                    return;
                }

                // Add aggregated game update to list of all notifications.
                $scope.notifications[aggregateNotification.id] = aggregateNotification;
                $scope.notificationIds.unshift(aggregateNotification.id);

                // Fill in game details and icons for models that still need them.
                gameUpdatesUtility.fillGameDetails(gameUpdateModels);

                if (aggregateNotification.metadataCollection.length === 1) {
                    singleGameUpdateModel = gameUpdateModels[aggregateNotification.metadataCollection[0].UniverseId];

                    // Send metrics event for single notification.
                    gameUpdatesService.markGameUpdateInteractedAsync(
                        singleGameUpdateModel.universeId,
                        singleGameUpdateModel.createdOnKey,
                        gameUpdatesConstants.gameUpdateInteractions.seen,
                        $scope.library.currentUserId
                    );
                }
            }
        );
    };

    $scope.getRecentNotifications = function () {
        $scope.layout.getRecentDataInitialized = false;

        notificationStreamService.getRecentNotifications(
            $scope.notificationApiParams.startIndexOfNotifications,
            $scope.notificationApiParams.pageSizeOfNotifications
        ).then(
            function (recentNotifications) {
                var gameUpdates = [], otherNotifications = [];

                $scope.layout.getRecentDataInitialized = true;
                $scope.layout.isGetRecentDataLoadedRequested = false;

                if (recentNotifications && recentNotifications.length > 0) {
                    // Separate game updates from other types of notifications.
                    angular.forEach(recentNotifications, function (entry) {
                        if (notificationStreamUtility.isGameUpdateNotification(entry.notificationSourceType)) {
                            gameUpdates.push(entry);
                        }
                        else {
                            otherNotifications.push(entry);
                        }
                    });

                    $scope.buildNotificationsList(otherNotifications);

                    if (gameUpdates.length > 0) {
                        $scope.buildGameUpdateNotifications(gameUpdates);
                    }

                    // Paging.
                    $scope.layout.isLazyLoadingRequested = true;
                    if (recentNotifications.length === $scope.notificationApiParams.pageSizeOfNotifications) {
                        $scope.notificationApiParams.startIndexOfNotifications = $scope.notificationApiParams.startIndexOfNotifications + $scope.notificationApiParams.pageSizeOfNotifications;
                        $scope.notificationApiParams.loadMoreNotifications = true;
                    }
                }
            },
            function () {
                $log.debug("--- getRecentNotifications call failed ----- ");
                $scope.layout.getRecentDataInitialized = true;
            }
        );
    }

    $scope.clearUnreadNotifications = function () {
        if ($scope.library.unreadNotifications > 0) {
            $scope.library.unreadNotifications = 0;
            $document.triggerHandler("Roblox.NotificationStream.UnreadNotifications",
                {
                    count: 0,
                    isNotificationContentOpen: $scope.layout.isNotificationContentOpen
                });
        }
    }

    $scope.openNotificationStream = function () {
        if ($scope.layout.isGetRecentDataLoadedRequested) {
            $scope.resetNotificationStreamData();
            $scope.getRecentNotifications();
        }
        if ($scope.library.unreadNotifications > 0) {
            notificationStreamService.clearUnread()
                .then(
                    function () {
                        $scope.clearUnreadNotifications();
                    }, function () {
                        $log.debug("--- clearUnread call failed ----- ");
                    });
        }
    }

    $scope.toggleNotificationContent = function (forceHidden) {
        if (forceHidden) {
            $scope.layout.isNotificationContentOpen = false;
        } else {
            $scope.layout.isNotificationContentOpen = !$scope.layout.isNotificationContentOpen;
            if ($scope.layout.isNotificationContentOpen && $scope.layout.isGetRecentDataLoadedRequested) {
                $scope.openNotificationStream();
                $scope.updatePopoverLayout();
            }
        }

        if ($scope.layout.isNotificationContentOpen && $scope.layout.bannerEnabled) {
            $scope.layout.bannerEnabled = false;
        }

        if ($scope.layout.isLazyLoadingRequested) {
            $scope.layout.isLazyLoadingRequested = false;
        }
    }

    $scope.getUnreadNotificationCount = function () {
        notificationStreamService.unreadCount()
            .then(
                function (data) {
                    if (data) {
                        $scope.library.unreadNotifications = data.unreadNotifications;
                        if (!$scope.layout.isNotificationContentOpen) {
                            $document.triggerHandler("Roblox.NotificationStream.UnreadNotifications",
                                {
                                    count: data.unreadNotifications,
                                    isNotificationContentOpen: $scope.layout.isNotificationContentOpen
                                });
                        } else {
                            $scope.layout.bannerText = notificationStreamUtility.textTemplate.newNotification($scope.library.unreadNotifications);
                        }
                    }
                },
                function () {
                    $log.debug("--- unreadCount call failed ----- ");
                }
            );
    }

    $scope.resetNotificationStreamData = function () {
        $scope.notificationIds = [];
        $scope.notifications = {};
        if ($scope.notificationApiParams) {
            $scope.notificationApiParams.startIndexOfNotifications = 0;
        }
    };

    $scope.reloadNotificationStreamData = function () {
        $scope.resetNotificationStreamData();
        if ($scope.library.unreadNotifications > 0) {
            notificationStreamService.clearUnread();
        }
        $scope.getRecentNotifications();
        $scope.layout.bannerEnabled = false;
    };

    $scope.updateNewNotificationInfo = function () {
        $scope.layout.isGetRecentDataLoadedRequested = true;
        $scope.getUnreadNotificationCount();
        if ($scope.layout.isNotificationContentOpen) {
            $scope.$evalAsync(function () {
                $scope.layout.bannerEnabled = true;
            });
        }
    };

    $scope.updateSettingsInLibrary = function (data) {
        $scope.library.currentUserId = CurrentUser.userId;
        $scope.library.inApp = DeviceMeta ? DeviceMeta().isInApp : false;
        $scope.library.isPhone = DeviceMeta ? DeviceMeta().isPhone : false;
        $scope.library.inAndroidApp = DeviceMeta ? DeviceMeta().isAndroidApp : false;
        $scope.library.iniOSApp = DeviceMeta ? DeviceMeta().isIosApp : false;
        $scope.library.inUWPApp = DeviceMeta ? DeviceMeta().isUWPApp : false;
        $scope.library.bannerDismissTimeSpan = data.bannerDismissTimeSpan;
        $scope.library.signalRDisconnectionResponseInMilliseconds = data.signalRDisconnectionResponseInMilliseconds;

        $scope.library.eventStreamMetaData = {
            userId: $scope.library.currentUserId,
            inApp: $scope.library.inApp
        };

        // Switch for launching game from game updates.
        $scope.library.canLaunchGameFromGameUpdate = data.canLaunchGameFromGameUpdate;
    };

    $scope.handleSignalRSuccess = function () {
        $scope.$evalAsync(function () {
            $scope.layout.errorBannerEnabled = false;
        });
    };

    $scope.handleSignalRError = function () {
        $timeout(function () {
            $scope.layout.errorBannerEnabled = true;
            $scope.layout.errorText = notificationStreamUtility.textTemplate.noNetworkConnectionText();
        }, $scope.library.signalRDisconnectionResponseInMilliseconds);
    };

    $scope.handleNotificationStreamNotification = function (data) {
        $log.debug("--------- this is NotificationStream subscription -----------" + data.Type);
        switch (data.Type) {
            case notificationStreamUtility.signalRType.NewNotification:
                $scope.updateNewNotificationInfo();
                break;
            case notificationStreamUtility.signalRType.NotificationsRead:
                $scope.clearUnreadNotifications();
                break;
            case notificationStreamUtility.signalRType.NotificationRevoked:
                $scope.getUnreadNotificationCount();
                if (!$scope.layout.isStreamBodyInteracted) {
                    $scope.reloadNotificationStreamData();
                }
                break;
        }
    };

    $scope.handleChatPrivacySettingNotification = function (data) {
        $log.debug("--------- this is ChatPrivacySettingNotifications subscription -----------" + data.Type);
        try {
            switch (data.Type) {
                case notificationStreamUtility.signalRType.chatEnabled:
                    $scope.library.isChatDisabledByPrivacySetting = false;
                    break;
                case notificationStreamUtility.signalRType.chatDisabled:
                    $scope.library.isChatDisabledByPrivacySetting = true;
                    break;
            }
        } catch (e) {
            var message = "ChatPrivacySettingNotifications:" + data.Type + ": ";
            if (e && e.message) {
                message += e.message;
            }
            $log.debug(message);
        }
    };

    $scope.getChatPrivacySetting = function () {
        notificationStreamService.getChatPrivacySettings()
            .then(
                function success(data) {
                    $scope.library.isChatDisabledByPrivacySetting = data && !data.chatEnabled;
            },
            function error(e) {
                $log.debug(e);
            });
    }

    //// ----------------------------------- SignalR --------------------------------
    $scope.initializeRealTimeSubscriptions = function () {
        if (angular.isDefined(RealTime)) {
            var realTimeClient = RealTime.Factory.GetClient();
            realTimeClient.SubscribeToConnectionEvents($scope.handleSignalRSuccess, $scope.handleSignalRSuccess, $scope.handleSignalRError, notificationStreamUtility.notificationsName.NotificationStream);

            realTimeClient.Subscribe(notificationStreamUtility.notificationsName.NotificationStream, $scope.handleNotificationStreamNotification);

            realTimeClient.Subscribe(notificationStreamUtility.notificationsName.ChatPrivacySettingNotifications, $scope.handleChatPrivacySettingNotification);
        }
    }

    //// ----------------------------------- CODE TO RUN --------------------------------

    function initializeLayout() {
        $scope.layout = angular.copy(notificationStreamUtility.layout);
        $scope.notificationApiParams = angular.copy(notificationStreamUtility.notificationApiParams);
        $scope.getUnreadNotificationCount();
        if ($scope.library.inApp) {
            $scope.openNotificationStream();
            $scope.layout.isNotificationContentOpen = true;
        }
    }

    function initializePageData() {
        try {
            $scope.library = notificationStreamUtility.library;
            $scope.resetNotificationStreamData();
            if (Popover) {
                Popover.init();
            }
            $scope.getChatPrivacySetting();

            notificationStreamService.initialize()
                .then(
                    function (data) {
                        if (data) {
                            notificationStreamUtility.layout.pageDataInitialized = true;
                            $scope.updateSettingsInLibrary(data);
                        }
                    },
                    function () {
                        $log.debug("----- initialize data request failed ----");
                    }
                );
        }
        catch (e) {
            var message = "initializePageData:";
            if (e && e.message) {
                message += e.message;
            }
            $log.debug(message);
        }
    }

    if (!notificationStreamUtility.layout.pageDataInitialized) {
        initializePageData();
    }

    $document.bind("Roblox.Popover.Status",
        function (event, args) {
            $log.debug("notificationStreamController");

            if ($scope.layout) {
                $scope.$evalAsync(function () {
                    if (!$scope.layout.isNotificationContentOpen && !args.isHidden) {
                        var property = angular.copy($scope.library.eventStreamMetaData);
                        property.countOfUnreadNotification = $scope.library.unreadNotifications;
                        eventStreamService.sendEventWithTarget(eventStreamService.eventNames.notificationStream.openContent, args.eventType, property);
                    }
                    $scope.toggleNotificationContent(args.isHidden);
                });

            }
        }
    );

    var watchPageDataInitialized = $scope.$watch(
        function () {
            return notificationStreamUtility.layout.pageDataInitialized;
        },
        function (newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue && newValue !== oldValue) {
                $log.debug("----- initializeLayout ----");
                initializeLayout();
                $scope.initializeRealTimeSubscriptions();
            }
        }
    );

    $scope.$on("$destroy", function () {
        if (watchPageDataInitialized) {
            watchPageDataInitialized();
        }
    });
}

notificationStreamModule.controller('notificationStreamController', notificationStreamController);

export default notificationStreamController;